import ClipboardJS from 'clipboard';

export default function copyLink() {
  const clipboard = new ClipboardJS('.js-copy-link', {
    text(trigger) {
      return trigger.getAttribute('data-value');
    }
  });

  clipboard.on('success', (e) => {
    $(e.trigger).find('.js-message').addClass('is-visible');
    setTimeout(() => {
      $(e.trigger).find('.js-message').removeClass('is-visible');
      e.clearSelection();
    }, 2000);
  });
}
